<template>
  <div class="tw-m-1" :class="widthClass">
    <SfSearch
      v-model="searchTerm"
      :show-clear-icon="true"
      :show-search-icon="true"
      :show-result-navigation="false"
      :placeholder="I18n.t('inbox.filters.search_input.placeholder')"
      @clear="onClear"
      @focus="onFocus"
      @blur="onBlur"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useInboxFiltersStore } from '../store/inbox-filters'
import SfSearch from '@app/shared/vue/components/sf-search/search-input.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { storeToRefs } from 'pinia'

const I18n = useI18n()
const inboxFiltersStore = useInboxFiltersStore()
const { searchTerm } = storeToRefs(inboxFiltersStore)
const isFocused = ref(false)
const hasValue = computed(() => searchTerm.value.length > 0)

const widthClass = computed(() => {
  return isFocused.value || hasValue.value ? 'tw-w-[300px]' : 'tw-w-[150px]'
})

function onClear(): void {
  searchTerm.value = ''
}

function onFocus(): void {
  isFocused.value = true
}

function onBlur(): void {
  isFocused.value = false
}
</script>
